
import * as Icons from "lucide-react";

type NodeIconProps = {
  category?: string;
};

const NodeIcon = ({ category }: NodeIconProps) => {
  switch (category) {
    case "Message":
      return <Icons.MessageSquare className="h-4 w-4 mr-2" />;
    case "Question":
      return <Icons.HelpCircle className="h-4 w-4 mr-2" />;
    case "Email":
      return <Icons.Mail className="h-4 w-4 mr-2" />;
    case "Multi-Choice":
      return <Icons.ListCheck className="h-4 w-4 mr-2" />;
    case "New Option":
      return <Icons.PlusSquare className="h-4 w-4 mr-2" />;
    case "AI Mode":
      return <Icons.Bot className="h-4 w-4 mr-2" />; 
    case "Image":
      return <Icons.Image className="h-4 w-4 mr-2" />;
    case "Video":
      return <Icons.Video className="h-4 w-4 mr-2" />;
    case "Loop":
      return <Icons.RefreshCw className="h-4 w-4 mr-2" />; 
    case "Redirect":
      return <Icons.ArrowRightToLine className="h-4 w-4 mr-2" />;
    case "Save Data":
      return <Icons.Save className="h-4 w-4 mr-2" />;
    default:
      return null;
  }
};

export default NodeIcon;
